import { useMemo } from 'react';
import { useNavigate } from 'react-router';
import { CultureIndexAreaMap } from 'types/Meteorology/Agro/CultureIndex/Area/map';
import useLocationMarkers from '../../useLocationMarkers';

export default function useMapLocationMarkers(areaMap: CultureIndexAreaMap) {
  const navigate = useNavigate();
  const locationMarkers = useLocationMarkers();

  const mapLocationMarkers = useMemo(() => {
    // Só permite clique se a consulta foi realizada (areaMap.data existe)
    if (!areaMap.data) {
      return locationMarkers;
    }

    return locationMarkers?.map((marker) => ({
      ...marker,
      onClick: () => {
        navigate('/agro/culture-index/location', {
          state: {
            groupId: marker.groupId,
            locationId: marker.locationId,
            culture: areaMap.params.culture,
            forecastDate: areaMap.params.forecastDate,
            periodStart: areaMap.params.periodStart,
            periodEnd: areaMap.params.periodEnd,
            stage: areaMap.params.stage,
          },
        });
      },
    }));
  }, [locationMarkers, navigate, areaMap]);

  return mapLocationMarkers;
}
